/*
 * @Author: ZJJ
 * @Date: 2025-11-17 11:50:40
 * @LastEditTime: 2025-11-17 14:22:22
 * @FilePath: /boluo_website/src/api/request.js
 * @Description:
 */
import sha256 from "js-sha256";

// 签名密钥（从环境变量获取）
const signKey = process.env.VUE_APP_SIGN_KEY || "";

/**
 * 生成随机字符串
 * @param {number} length 字符串长度
 * @returns {string} 随机字符串
 */
export function generateNonce(length = 16) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * 生成签名
 * @param {Object} params 请求参数
 * @param {string} nonce 随机字符串
 * @returns {string} 签名字符串（大写）
 */
export function generateSign(params = {}, nonce) {
  // 深拷贝参数，避免修改原对象
  const signParams = JSON.parse(JSON.stringify(params));

  // 添加随机字符串
  signParams.nonceStr = nonce;

  // 1. 参数按键名排序
  const sortedKeys = Object.keys(signParams).sort((a, b) => a.localeCompare(b));

  // 2. 构建参数字符串 key1=value1&key2=value2
  const sortedParams = sortedKeys
    .map(key => `${key}=${signParams[key]}`)
    .join("&");

  // 3. 拼接密钥：参数&key=密钥
  const signString = `${sortedParams}&key=${signKey}`;
  // console.log("signString", signString);
  // 4. SHA256 加密并转大写
  return sha256(signString).toUpperCase();
}
